//import library
window.$ = jQuery;

import "popper.js";

import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/regular";
import "@fortawesome/fontawesome-free/js/brands";

import "bootstrap";

import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

export default {
  init() {
    $(window).scroll(function () {
      const headerTop = $(".header-top");
      const shrinkIt = headerTop.height();
      const scroll = $(window).scrollTop();

      if (scroll >= shrinkIt) {
        $(".main-menu").addClass("fixed-menu");
      } else {
        $(".main-menu").removeClass("fixed-menu");
      }
    });

    $(document).on("lazybeforesizes", function (e) {
      (e.orginalEvent || e).detail.width =
        $(e.target).parents(":not(picture)").innerWidth() || e.detail.width;
    });

    const openSearchFormButton = document.querySelector(
      "a.open-search-form-button"
    );

    const closeSearchFormButton = document.querySelector(
      "a.close-search-form-button"
    );

    const searchMenu = document.querySelector("div.search-menu");
    const searchText = document.querySelector("input#search-text");
    const openMobileMenuButton = document.querySelector(
      "a.open-mobile-menu-button"
    );
    const closeMobileMenuButton = document.querySelector(
      "a.close-mobile-menu-button"
    );
    const mobileMenu = document.querySelector("div.mobile-menu");
    const body = document.querySelector("body");
    const html = document.querySelector("html");

    openSearchFormButton.addEventListener("click", function () {
      searchMenu.classList.add("opened");
      mobileMenu.classList.remove("opened");
      setTimeout(() => {
        searchText.focus();
      }, 100);
    });

    closeSearchFormButton.addEventListener("click", function () {
      searchMenu.classList.remove("opened");
    });

    openMobileMenuButton.addEventListener("click", function (e) {
      searchMenu.classList.remove("opened");
      mobileMenu.classList.toggle("opened");
      body.style.overflowY = "hidden";
      html.style.overflowY = "hidden";
    });

    closeMobileMenuButton.addEventListener("click", function (e) {
      mobileMenu.classList.remove("opened");
      body.style.overflowY = "auto";
      html.style.overflowY = "auto";
    });

    const backToMainMenuButtons = document.querySelectorAll(
      "a.back-to-main-menu"
    );

    backToMainMenuButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();

        const targetCheckboxId = btn.dataset.href;
        const targetCheckbox = document.getElementById(targetCheckboxId);
        targetCheckbox.checked = false;
      });
    });

    document.addEventListener("mouseup", (e) => {
      if (e.target == mobileMenu && mobileMenu.classList.contains("opened")) {
        mobileMenu.classList.remove("opened");
        body.style.overflowY = "auto";
        html.style.overflowY = "auto";
      }
    });
  },
};
